import React from "react";
import { useParams } from "react-router";
import MenuButton from "../MenuButton/MenuButton";
import PostAssessmentForm from "./PostAssessmentForm";

/** Add page: only the Client Fitness Assessment Form. */
export default function PostAssessment() {
  const { id } = useParams();

  return (
    <div className="wrapper">
      <main className="page-content customer-contnent">
        <div className="site-main-design">
          <MenuButton />
          <div className="card">
            <PostAssessmentForm id={id} length={0} />
          </div>
        </div>
      </main>
    </div>
  );
}
